import { ref } from 'vue';
import { GroupQuery } from '@/services/api/resources/group/query';
import { useTask } from '@/ui/concerns';
import { list } from '@/services/api/resources/group';
import { sequence } from '@/ui/helpers';

export const useGroupCheck = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>();

  const query = (): GroupQuery => ({
    search: '',
    sort: '',
    dir: '',
    page: 1,
    perPage: 1,
  });

  const performCheck = useTask(
    () => sequence(
      list(query()),
    ),
    ([
      listResponse,
    ]) => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
